<template>
  <div>
  <div class="leaderboard_user_info">
    <div class="leaderboard_stats_box">
      <div class="leaderboard_stats_container">
        <div class="home_row flex-row">
          <div class="home_column flex-column">
            <img :src="userAvatar">
          </div>
          <div class="home_column flex-column leaderboard_stats_row">
            <div class="home_row flex-row">
              <h1>{{ userDetails.name }}</h1>
            </div>
            <div class="home_row flex-row points_leaderboard">
              <div class="leaderboard_stats">
                <p class="points_item">
                  {{ userPoints }}
                </p>
                <label>{{ getTranslations.home_leaderboard_points }}</label>
              </div>
              <div class="vertical_line_leaderboard"></div>
              <div class="leaderboard_stats">
                <p v-if="userPoints !== 0">{{ numberFormatting(getRank.rank) }}</p>
                <p v-else>0</p>
                <label>{{ getTranslations.home_leaderboard_rank }}</label>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="border_line"></div>
      <fb-share-rank v-if="winners && getRank && facebookFunctionality"
                     :ranks="getRank"
                     :winners="winners"
                     :updatePoints="updatePoints"
                     :type="type"
                     :day="day">
      </fb-share-rank>
    </div>
  </div>
    <div v-if="userPoints !== 0" class="leaderboard_rank_box">
      <h1>{{ getTranslations.home_leaderboard_title }}</h1>
      <user-list :is-modal="false">
        <template slot="content">
          <virtual-list :data-key="'username'"
                        :items="getProps()"
                        :wrapperType="'prize_user'"
                        :remain="7"
                        :estimated="150"/>
        </template>
      </user-list>
    </div>
    <div v-else class="performance_box leaderboard empty">
      <h1>{{ getTranslations.home_leaderboard_title }}</h1>
      <img src="static/images/profile/profile-emptystate.png">
      <p>{{ getTranslations.home_leaderboard_empty }}</p>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import NumbersFormattingMixin from '@/common/mixins/numbersFormatting';
import UserList from '@/components/home/sharedcomponents/GenericList';
import VirtualList from '@/components/home/sharedcomponents/VirtualScrollList';
import FbShareRank from './FbShareRank';

export default {
  name: 'prize-tab',
  props: {
    day: {
      type: Number,
    },
    type: {
      type: String,
    },
    winners: {
      type: Array,
      default: () => [],
    },
    getRank: {
      type: Object,
    },
    userPoints: {
      type: Number,
      default: 1,
    },
    updatePoints: {
      type: Function,
    },
    refreshedDate: {
      type: String,
    },
    getDateFormat: {
      type: Function,
    },
  },
  mixins: [NumbersFormattingMixin],
  components: {
    FbShareRank,
    UserList,
    VirtualList,
  },
  provide: {
    isRank: true,
  },
  methods: {
    getProps() {
      return this.winners
        .map(user => ({ ...user, isFavorite: user.favorite, active: user.msisdn === this.userDetails.msisdn }));
    },
  },
  computed: {
    ...mapState('common', [
      'userDetails',
      'facebookFunctionality',
      'userAvatar',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/prizesAndLeaderboards/PrizeTab.vue